<template>
    <div class="container">
      <PayTemp></PayTemp>
    </div>
</template>

<script>
  import PayTemp from '@/components/doorHelp/PayTemp'
    export default {
      data(){
        return {
        }
      },
      components:{
        PayTemp
      },
      mounted(){
        window.addEventListener("popstate", function(e) {
          WeixinJSBridge.call('closeWindow');
        }, false);
      }
    }
</script>

<style scoped lang="scss">
  .container{
    background:#F8F8F8;
    position: relative;
    @include width_height_100();
  }
</style>



// WEBPACK FOOTER //
// src/views/doorHelp/payApply.vue